<oth-card [bodyTemplate]="bodyTemplate" [headerTemplate]="headerTemplate"
          class="policy-card">
  <!-- Header -->
  <ng-template #headerTemplate>
    <ng-container *ngTemplateOutlet="policyHeader || defaultPolicyHeader">
      <!-- Header of the card -->
    </ng-container>
    <ng-template #defaultPolicyHeader>
      <div *ngIf="defaultHeaderContent" class="header">
        {{ defaultHeaderContent }}
      </div>
    </ng-template>
  </ng-template>

  <!-- Body -->
  <ng-template #bodyTemplate>
    <div class="body">
      <ng-container *ngTemplateOutlet="policyBody || defaultPolicyBody">
        <!-- Body of the card -->
      </ng-container>
      <ng-template #defaultPolicyBody>
        <div *ngIf="defaultBodyContent" class="body">
          {{ defaultBodyContent }}
        </div>
      </ng-template>
    </div>
  </ng-template>

</oth-card>
